<p>mail-check-resend works!</p>
